// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---packages-gatsby-theme-googlesheets-personal-web-src-pages-404-js": () => import("./../../../../packages/gatsby-theme-googlesheets-personal-web/src/pages/404.js" /* webpackChunkName: "component---packages-gatsby-theme-googlesheets-personal-web-src-pages-404-js" */),
  "component---src-pages-contact-mdx": () => import("./../../../src/pages/contact.mdx" /* webpackChunkName: "component---src-pages-contact-mdx" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-publications-js": () => import("./../../../src/pages/publications.js" /* webpackChunkName: "component---src-pages-publications-js" */),
  "component---src-pages-teaching-mdx": () => import("./../../../src/pages/teaching.mdx" /* webpackChunkName: "component---src-pages-teaching-mdx" */)
}

